"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureStorage = void 0;
const __1 = require("../..");
class SignatureStorage {
    constructor(arcxLogger, signaturesCollection, defaultChainId) {
        this.arcxLogger = arcxLogger;
        this.signaturesCollection = signaturesCollection;
        this.defaultChainId = defaultChainId;
    }
    createSignature(chainId, newSignature) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.signaturesCollection[(0, __1.getNetworkGroup)(chainId)].insertOne(newSignature);
            }
            catch (error) {
                this.arcxLogger.error(`SignatureStorage::createSignature => Could not create signatures: ${error}`);
            }
        });
    }
    readSignatures(chainId, epoch, account) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const query = Object.assign(Object.assign({}, (epoch && { epoch })), (account && { account }));
                const signatures = (yield this.signaturesCollection[(0, __1.getNetworkGroup)(chainId)]
                    .find(query)
                    .toArray());
                return signatures;
            }
            catch (error) {
                const errMessage = `SignatureStorage::readSignatures => Could not read signatures: ${error}`;
                this.arcxLogger.error(errMessage);
                return [];
            }
        });
    }
    deleteSignaturesBefore(epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.signaturesCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].deleteMany({
                    epoch: { $lt: epoch },
                });
            }
            catch (error) {
                this.arcxLogger.error(`SignatureStorage::deleteSignaturesBefore => ${error}`);
            }
        });
    }
}
exports.SignatureStorage = SignatureStorage;
//# sourceMappingURL=SignatureStorage.js.map